import { render, staticRenderFns } from "./listaBeneficiado.vue?vue&type=template&id=e09ab4a8&scoped=true&"
import script from "./listaBeneficiado.vue?vue&type=script&lang=js&"
export * from "./listaBeneficiado.vue?vue&type=script&lang=js&"
import style0 from "./listaBeneficiado.vue?vue&type=style&index=0&id=e09ab4a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09ab4a8",
  null
  
)

export default component.exports